// Copyright 2025. WebPros International GmbH. All rights reserved.

export const START_DISASTER_RECOVERY_MODAL = {
    SELECT_DESTINATION_CR: 'select-destination-compute-resource',
    SUBMIT_BTN: 'start-disaster-recovery-submit-btn',
};